import axios from 'axios';
import { toast } from 'sonner';
import { downloadBlob } from '../../utils/fileUtils';

export const API_GUIDE = '/guide-bpjeps/bc1-bc2';
export const PDF_GUIDE = '/guide-bpjeps/bc1-bc2.pdf';

export const telecharger = async (url, nom) => {
  try {
    const { data, headers } = await axios.get(url, { responseType: 'blob', timeout: 90000 });
    const serveur = /filename="([^"]+)"/.exec(headers['content-disposition'] || '');
    downloadBlob(data, serveur ? serveur[1] : nom);
  } catch {
    toast.error('Téléchargement impossible, réessayez dans un instant.');
  }
};

export const TEINTES = {
  teal: { fort: 'bg-[#0E7C74]', texte: 'text-[#0E7C74]', clair: 'bg-[#E6F4F2]', bord: 'border-[#0E7C74]', barre: 'bg-[#0E7C74]' },
  coral: { fort: 'bg-[#E2583E]', texte: 'text-[#E2583E]', clair: 'bg-[#FDECE8]', bord: 'border-[#E2583E]', barre: 'bg-[#E2583E]' },
};

export const STATUTS = [
  { cle: 'a_faire', label: 'Pas commencé', actif: 'bg-slate-700 text-white', pastille: 'bg-slate-300' },
  { cle: 'en_cours', label: 'En cours', actif: 'bg-amber-500 text-white', pastille: 'bg-amber-400' },
  { cle: 'pret', label: 'Prêt', actif: 'bg-emerald-600 text-white', pastille: 'bg-emerald-500' },
];

export const criteresDe = (bloc) => bloc.activites.flatMap((a) => a.criteres);
export const idsDe = (criteres) => criteres.flatMap((c) => c.indicateurs.map((i) => i.id));

export const Barre = ({ pret, total, couleur = 'bg-emerald-500', className = '', testId }) => (
  <div className={`h-2 overflow-hidden rounded-full bg-slate-200/70 ${className}`} data-testid={testId}>
    <div className={`h-full rounded-full transition-[width] duration-500 ${couleur}`} style={{ width: `${total ? (100 * pret) / total : 0}%` }} />
  </div>
);

export const Section = ({ titre, sousTitre, children, className = '', testId }) => (
  <section className={`rounded-2xl border border-slate-200 bg-white p-5 shadow-sm sm:p-7 ${className}`} data-testid={testId}>
    {titre && <h2 className="text-base font-bold text-[#0F172A] md:text-lg">{titre}</h2>}
    {sousTitre && <p className="mt-1 text-sm text-slate-500">{sousTitre}</p>}
    <div className={titre ? 'mt-5' : ''}>{children}</div>
  </section>
);

export const Puce = ({ children }) => (
  <li className="flex gap-2.5 text-sm leading-relaxed text-slate-700"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#8DC63F]" />{children}</li>
);

export const Tableau = ({ o, teinte }) => (
  <div className="overflow-x-auto rounded-xl border border-slate-200">
    <table className="w-full min-w-[560px] text-left text-sm">
      <thead className={`${teinte.fort} text-white`}><tr>{o.colonnes.map((c) => <th key={c} className="px-3 py-2.5 text-xs font-semibold">{c}</th>)}</tr></thead>
      <tbody>
        {o.lignes.map((l, r) => (
          <tr key={`${r}-${l.join('|')}`} className="border-t border-slate-100 odd:bg-white even:bg-slate-50">
            {l.map((v, k) => <td key={`${k}-${v}`} className={`h-9 px-3 py-2 align-top text-slate-700 ${k === 0 ? 'font-semibold text-[#0F172A]' : ''}`}>{v}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

// Texte avec passages **en gras**
export const Riche = ({ texte }) => texte.split(/\*\*(.+?)\*\*/).map((m, k) => (k % 2 ? <strong key={k} className="font-bold text-[#0F172A]">{m}</strong> : m));
